import { render } from "./DataProvided.vue?vue&type=template&id=eb5f7764"
import script from "./DataProvided.vue?vue&type=script&lang=js"
export * from "./DataProvided.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__